import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './profil.css';
import AccueilButtons from './Components/Accueil-buttons';
import { getPlayerStatistics, updateDisplayName, getPlayerProfile, updateAvatarUrl } from './api';

const Profile = () => {
  const location = useLocation();
  const [displayName, setDisplayName] = useState(localStorage.getItem('displayName') || 'Utilisateur');
  const [newDisplayName, setNewDisplayName] = useState(displayName);
  const [imageUrl, setImageUrl] = useState(localStorage.getItem('imageUrl') || ''); // Remplacer avatarUrl par imageUrl
  const [newImageUrl, setNewImageUrl] = useState(imageUrl);
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const playFabId = location.state?.playFabId || localStorage.getItem('playFabId');
        if (!playFabId) {
          throw new Error('PlayFabId not available');
        }

        const profileResponse = await getPlayerProfile(playFabId);
        setDisplayName(profileResponse.displayName);
        setNewDisplayName(profileResponse.displayName);
        setImageUrl(profileResponse.avatarUrl || ''); // Remplacer avatarUrl par imageUrl
        setNewImageUrl(profileResponse.avatarUrl || ''); // Remplacer avatarUrl par imageUrl

        const statsResponse = await getPlayerStatistics(playFabId);
        setStatistics(statsResponse.data.Statistics);

        setLoading(false);
      } catch (err) {
        setError('Erreur lors du chargement des informations.');
        setLoading(false);
        console.error(err);
      }
    };

    fetchData();
  }, [location.state]);

  const handleDisplayNameChange = async () => {
    try {
      const playFabId = localStorage.getItem('playFabId');
      await updateDisplayName(playFabId, newDisplayName);
      setDisplayName(newDisplayName);
      localStorage.setItem('displayName', newDisplayName);

      setSuccess('Nom d\'utilisateur mis à jour avec succès.');
      setNewDisplayName('');
    } catch (err) {
      setError('Erreur lors de la mise à jour du nom d\'utilisateur.');
      console.error(err);
    }
  };
  
  // Fonction de redimensionnement des images
  const resizeImage = (file, width = 100, height = 100) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onloadend = () => {
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          const resizedImage = canvas.toDataURL('image/png');
          resolve(resizedImage);
        };
        img.src = reader.result;
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleImageUrlChange = async () => {
    try {
      const playFabId = localStorage.getItem('playFabId');
      if (selectedImage) {
        // Redimensionner l'image à 100x100px
        const resizedImage = await resizeImage(selectedImage, 100, 100); // Spécifier 100x100px pour la taille
        await updateAvatarUrl(playFabId, resizedImage); // Mettre à jour l'avatar avec l'image redimensionnée
        setImageUrl(resizedImage); // Mettre à jour l'URL de l'avatar dans l'état
        localStorage.setItem('imageUrl', resizedImage); // Sauvegarder dans le localStorage
  
        setSuccess('Avatar mis à jour avec succès.');
      }
    } catch (err) {
      setError('Erreur lors de la mise à jour de l\'avatar.');
      console.error(err);
    }
  };
  

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (file) {
      setSelectedImage(file); // Store the file for later use
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUrl(reader.result); // Set the image preview as avatar URL (remplacer avatarUrl par imageUrl)
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="profil-container">
      <h2>Profil</h2>
      <div className="Rectangle56"></div>
            <div className="Rectangle102"></div>
            <div className="Rectangle103"></div>
            <div className="Rectangle114"></div>
            <div className="Rectangle109"></div>
            <div className="Rectangle110"></div>
            <div className="Rectangle108"></div>
            <div className="Rectangle107"></div>
            <div className="Rectangle104"></div>
            <div className="Rectangle101"></div>
            <div className="Rectangle78"></div>
            <div className="Rectangle111"></div>
            <div className="Rectangle106"></div>
            <div className="Group8"></div>
            <div className="Eclipse6"></div>
            <div className="Int">.Int</div>
      
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}

      <div className="display-name-section">
        <p>Nom d'utilisateur actuel : {displayName}</p>
        <input
          type="text"
          placeholder="Nouveau nom d'utilisateur"
          value={newDisplayName}
          onChange={(e) => setNewDisplayName(e.target.value)}
        />
        <button onClick={handleDisplayNameChange}>Mettre à jour</button>
      </div>

      <div className="avatar-section">
        <p></p>
        {imageUrl ? (
          <img src={imageUrl} alt="Avatar" className="avatar-image" /> // Remplacer avatarUrl par imageUrl
        ) : (
          <p></p>
        )}

        {/* Bouton circulaire avec icône de crayon */}
        <label htmlFor="avatar-upload" className="avatar-edit-button">
          <div className="photo-icon"></div>  {/* Utilisez "photo-icon" ici */}
        </label>
        <input
          type="file"
          id="avatar-upload"
          accept="image/*"
          style={{ display: 'none' }} // Cacher le champ de sélection
          onChange={handleImageChange}
        />
        <button onClick={handleImageUrlChange}>Mettre à jour Avatar</button> {/* Remplacer handleAvatarUrlChange par handleImageUrlChange */}
      </div>

      <div className="statistics-section">
        <h3>Statistiques</h3>
        {loading ? (
          <div className="loading">
            Chargement
            <span className="loading-dots">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </div>
        ) : (
          <ul>
            {statistics.map(stat => (
              <li key={stat.StatisticName}>
                {stat.StatisticName}: {stat.Value}
              </li>
            ))}
          </ul>
        )}
      </div>

      <AccueilButtons />
    </div>
  );
};

export default Profile;
